import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { Medicamento } from './medicamento.model';
import { DefaultService } from 'src/app/core/framework/default-service';
import { ProdutoFilter } from '../produto/produto.filter';


export interface MedicamentoFilter extends ProdutoFilter {
  apresentacao?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MedicamentoService extends DefaultService<Medicamento> {

  constructor(
    public httpClient: HttpClient,
    public errorHandler: ErrorHandlerService
  ) {
      super(
        httpClient,
        errorHandler,
        '/api/produto/v1/medicamentos'
      );
  }

}

